import React from 'react';
import PropTypes from 'prop-types';
import { View, Modal, StyleSheet, Platform } from 'react-native';
import { JDTouchable, JDImage, JDText, JDDevice, JDJumping, JDNativeSystem } from '@jdreact/jdreact-core-lib';

import { isIos, isWeb } from '../../utils/device';

const assets = require('./assets');

const NAVIGATION_BAR_HEIGHT = 44;

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
  },
  wrapper: {
    position: 'absolute',
    top: (NAVIGATION_BAR_HEIGHT - 5) + (isIos() ? JDNativeSystem.statusBarHeight : 0),
    right: 16,
  },
  arrowWrapper: {
    alignItems: 'flex-end',
    paddingRight: 10,
    height: 7,
    overflow: 'hidden',
  },
  arrow: {
    width: 15,
    height: 15,
    backgroundColor: 'rgba(0,0,0,0.65)',
    top: 3,
    transform: [{ rotate: '45deg' }],
  },
  moreNavList: {
    borderRadius: JDDevice.getDpx(8),
    paddingLeft: 13,
    paddingRight: 13,
    width: 140,
  },
  navItem: {
    borderTopColor: '#515358',
    borderTopWidth: JDDevice.getDpx(1),
    flexDirection: 'row',
    height: 41,
    alignItems: 'center',
  },
  navIcon: {
    width: 21,
    height: 21,
    resizeMode: 'cover',
  },
  navText: {
    color: '#FFF',
    fontSize: 15,
    marginLeft: 16,
  },
});

const DEFAULT_MORE_NAV_CONFIG = [
  {
    icon: assets.webview_nav_home,
    text: '首页',
    handler: () => {
      if (isWeb()) {
        JDJumping.jumpToWeb('https://m.jd.com/');
      }
      JDJumping.jumpToAppHome();
    },
  },
  {
    icon: assets.webview_nav_search,
    text: '搜索',
    handler: () => {
      if (isWeb()) {
        JDJumping.jumpToWeb('https://so.m.jd.com/category/all.html');
      }
      JDJumping.jumpToOpenapp('openApp.jdMobile://virtual?params={"category":"jump","des":"search","keyword":"****"}');
    },
  },
  {
    icon: assets.webview_nav_cart,
    text: '购物车',
    handler: () => {
      if (isWeb()) {
        JDJumping.jumpToWeb('https://p.m.jd.com/cart/cart.action');
      }
      JDJumping.jumpToOpenapp('openApp.jdMobile://virtual?params={"category":"jump","des":"cartB","skuId":"0","skuNum":"0"}');
    },
  }
];

// h5端没有消息
if (!isWeb()) {
  DEFAULT_MORE_NAV_CONFIG.splice(0, 0, {
    icon: assets.webview_nav_message,
    text: '消息',
    handler: () => {
      JDJumping.jumpToOpenapp('openApp.jdMobile://virtual?params={"category":"jump","des":"myMessageBox"}');
    },
  });
}

// 反馈
DEFAULT_MORE_NAV_CONFIG.push({
  icon: assets.webview_nav_feedback,
  text: '功能反馈',
  handler: () => {
    JDJumping.jumpToOpenapp('openApp.jdMobile://virtual?params={"category":"jump","sourceValue":"","sourceType":"","des":"feedback","from":"jingdongpaimai"}');
  }
});


export default class MoreModal extends React.PureComponent {
  static contextTypes = {
    router: PropTypes.object,
  }

  static propTypes = {
    moreNavList: PropTypes.array,
    backgroundColor: PropTypes.string,
  }

  static defaultProps = {
    moreNavList: DEFAULT_MORE_NAV_CONFIG,
    backgroundColor: 'rgba(0,0,0,.7)',
  }

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  onNavClick(handler) {
    this.onHide();
    if (typeof handler === 'function') {
      handler();
    }
  }

  onShow() {
    this.setState({
      visible: true,
    });
  }

  onHide() {
    this.setState({
      visible: false,
    });
  }

  render() {
    return (
      <Modal onRequestClose={() => {}} transparent={true} visible={this.state.visible}>
        <JDTouchable style={styles.overlay} onPress={() => { this.onHide(); }} />
        <View style={styles.wrapper}>
          <View style={styles.arrowWrapper}>
            {/* <Triangle width={15} height={7} color={this.props.backgroundColor} direction={'up'} /> */}
          </View>
          <View style={[styles.moreNavList, { backgroundColor: this.props.backgroundColor }]}>
            {
              React.Children.count(this.props.children) === 0
              ? (this.props.moreNavList || []).map((item, index) => (
                  <JDTouchable onPress={this.onNavClick.bind(this, item.handler, index)} contentContainerStyle={[styles.navItem, index === 0 && { borderTopWidth: 0 }]} key={`item-${index}`}>
                    <JDImage source={item.icon} style={styles.navIcon} />
                    <JDText style={styles.navText}>{item.text}</JDText>
                  </JDTouchable>
                ))
              : this.props.children
            }
          </View>
        </View>
      </Modal>
    );
  }
}
